import { get } from 'api/apiRequest';

export const backgroundJobs = {
  getBackgroundJobStatus: <T>(jobId: number) =>
    get<T>(`v1/backgroundjob/${jobId}/status`),
};
